import gql from 'graphql-tag';
import USER_FRAGMENT from '../../fragment/user';

export default gql`

query currentUser {
  user {
    ...UserFields
  }
}

${USER_FRAGMENT}

`;
